import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import ApiServer from "../../ApiServer.ts";
import * as libLocation from "../../lib/location.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as Locale from "../../util/Locale.ts";

import MAIN_MODAL from "../../list/modal_listcategories.mustache";
import TPL_ITEM from "../../list/modal_listcategories_item.mustache";
import { registerDragStart } from "../../lib/FileUtils.ts";

let list: any, theModal: HTMLElement, preparedPut: any;

Html.registerDom({
  tasklistcategorymanage:function(): void {
    const
      metaId = Html.getDomMetaId(this),
      locale = Locale.get().substring(0,2);

    list = FwDatas.get(metaId);
    var categories = list.getCategories(true);

    preparedPut = ApiServer.taskcategoryput.prepare({
      tasklistId:metaId,
      locale:locale,
      taskListType:list.taskListType,
      filterTasklistId:list.taskListType==='OTHER'?metaId:undefined
    });

    theModal = modal.openDomModal(MAIN_MODAL,{categories:categories,isEmpty:categories.length===0});

    function update(target: HTMLInputElement): void {
      const
        catNode = target.closest(".listcategoryedit") as HTMLElement,
        metaId = Html.getDomMetaId(catNode),
        emojiInput = catNode.querySelector('input[name=emoji]') as HTMLInputElement,
        nameInput = catNode.querySelector('input[name=name]') as HTMLInputElement,
        emoji = emojiInput?.value,
        name = nameInput?.value;

      if(metaId){
        let catFromCache = FwDatas.get(metaId)
        catFromCache.name = name;
        catFromCache.emoji = emoji;

        (theModal as any).modified = true;
        preparedPut({metaId:metaId,name:name,emoji:emoji||'🏷️'},function(){
          nameInput.classList.remove('fw-form-invalid-control')
        },function(){
          nameInput.classList.add('fw-form-invalid-control')
        })

      }else if(name){
        (theModal as any).modified = true;
        preparedPut({name:name,emoji:emoji||'🏷️'},function(cat: any){
          Html.replaceWithSingleDom(catNode,TPL_ITEM,cat)
          displayEmpty()
        });
      }else if(emoji){
        //just emoji we wait for a name
      }else{
        catNode.remove()
      }
    }
    theModal.addEventListener('change', Html.createDelegateListener(
      'input',
      function(ev: Event, target: HTMLInputElement){
        update(target);
      }
    ));
    (theModal as any).modified = false;
    theModal.onClose=function(){
      if((theModal as any).modified){
        libLocation.refresh();
      }
    }
  },
  listcatclick(): void {
    const input = this.parentElement?.querySelector('input') as HTMLInputElement;
    if(input){
      input.focus();
      setTimeout(function(){input.select()},50);
    }
  },
  async listcatdelete(): Promise<void> {
    const
      catNode = this.closest(".listcategoryedit") as HTMLElement,
      metaId = Html.getDomMetaId(catNode);
    if(metaId){
      if(!await modal.confirmDelete("mp.categoriesaskdelete")) return;

      (theModal as any).modified = true;
      await ApiServer.taskcategorydelete(metaId)
    }
    catNode.style.transition = 'opacity 300ms';
    catNode.style.opacity = '0';
    setTimeout(() => {
      catNode.remove();
      setTimeout(() => displayEmpty(), 100);
    }, 300);
  },
  listcataddfield:function(): void {
    const container = this.previousElementSibling as HTMLElement;
    const catNode = Html.setHtmlAtEndDom(container,TPL_ITEM,{emoji:'🏷️',rights:{canUpdate:true,canDelete:true}});
    const nameInput = catNode.querySelector('input[name=name]') as HTMLInputElement;
    if(nameInput) nameInput.focus();
  }
})
function displayEmpty(): void {
  const emptyEl = theModal.querySelector('.empty') as HTMLElement;
  const categories = theModal.querySelectorAll('.listcategoryeditdroppable .listcategoryedit');
  if(emptyEl){
    emptyEl.style.display = categories.length === 0 ? '' : 'none';
  }
}


registerDragStart(".listcategoryedit",async function(this: HTMLElement, ev: DragEvent, dropPromiseBuilder: any){
  const
    movingNode = this,
    potentialDrop = Array.from(document.querySelectorAll('.listcategoryedit')),
    dropEvent = await dropPromiseBuilder(this,potentialDrop),
    dropNode = Html.getDomMetaIdNode(dropEvent.target);

  let nodeBefore: HTMLElement | null = null;
  const rect = dropNode.getBoundingClientRect();
  if(rect.top + rect.height/2 > dropEvent.clientY){
    nodeBefore = dropNode.previousElementSibling as HTMLElement;
    dropNode.parentNode!.insertBefore(movingNode, dropNode);
  }else{
    nodeBefore = dropNode;
    if(dropNode.nextSibling){
      dropNode.parentNode!.insertBefore(movingNode, dropNode.nextSibling);
    }else{
      dropNode.parentNode!.appendChild(movingNode);
    }
  }
  let catFromCache = FwDatas.get(Html.getDomMetaId(movingNode));
  const nodeBeforeId = nodeBefore ? Html.getDomMetaId(nodeBefore) : null;
  (theModal as any).modified = true;
  preparedPut(new ApiServer.types.TaskCategoryInputBean({metaId:catFromCache.metaId}),nodeBeforeId||"$empty",function(cat: any){
    Html.replaceWithSingleDom(movingNode,TPL_ITEM,cat);
  })

})


document.addEventListener('focus', Html.createDelegateListener(
  '.listcategoryedit input',
  function(ev: FocusEvent, target: HTMLInputElement){
    const node = Html.getDomMetaIdNode(target);
    node.dataset.original = target.value;
    const clickBtn = node.querySelector('[data-fw-onclick="listcatclick"]') as HTMLElement;
    const deleteBtn = node.querySelector('[data-fw-onclick="listcatdelete"]') as HTMLElement;
    if(clickBtn) clickBtn.style.display = 'none';
    if(deleteBtn) deleteBtn.style.display = '';
  }
), true);

document.addEventListener('blur', Html.createDelegateListener(
  '.listcategoryedit input',
  function(ev: FocusEvent, target: HTMLInputElement){
    setTimeout(()=>{
      const node = Html.getDomMetaIdNode(target);
      const clickBtn = node.querySelector('[data-fw-onclick="listcatclick"]') as HTMLElement;
      const deleteBtn = node.querySelector('[data-fw-onclick="listcatdelete"]') as HTMLElement;
      if(clickBtn) clickBtn.style.display = '';
      if(deleteBtn) deleteBtn.style.display = 'none';
    },50)
  }
), true);

document.addEventListener('keypress', Html.createDelegateListener(
  '.listcategoryedit input',
  function(ev: KeyboardEvent, target: HTMLInputElement){
    if(ev.keyCode===13 || ev.keyCode===10){
      ev.preventDefault();
      target.blur();
    }
  }
));
